let host = `http://${location.host}`,
  login = "https://dsp.octomax.net/adsLogin", //登陆地址
  testLogin = "https://test-portal.octomax.net/adsLogin", //测试登陆地址
  loginApi = "https://login.octomax.net/auth/login", //登录接口
  testloginApi = "https://login.octomax.net/auth/login", // 目前和线上用一个接口
  dspHost, //dsp域名
  dspDomain, //dsp接口地址
  dspAdminHost, //管理后台域名
  mediaDomain;
console.log("host", host);

// 开发环境
if (location.host.includes("localhost")) {
  host = "https://test-portalapi.octomax.net";
  login = host + "/adsLogin";
  loginApi = testloginApi;
  dspHost = host;
  dspDomain = "/api";
  dspAdminHost = "https://test-portal-admin.octomax.net/index.html#/";
}
// 测试环境
else if (location.host.includes("test-portal-admin.octomax.net")) {
  login = testLogin;
  loginApi = testloginApi;
  dspHost = "https://test-portal.octomax.net";
  dspDomain = "https://test-portalapi.octomax.net";
  dspAdminHost = "https://test-portal-admin.octomax.net/index.html#/";
}
// 正式环境
else {
  dspHost = "https://dsp.octomax.net";
  dspDomain = "https://dspapi.octomax.net";
  dspAdminHost = "https://admin-dsp.octomax.net/index.html#/";
}

// if (location.host.includes('localhost')) {
//     //本地开发
//     host = '//test.group.batmobi.net';
//     login = testLogin;
//     loginApi = testloginApi
//     dspHost = '//test.group.batmobi.net';
//     dspDomain = '/api';
//     dspAdminHost = '//test.admin.batmobi.net/index.html#/';
//     mediaDomain = '//testapi-td.batmobi.net';
// } else if (location.host.includes('test.group.batmobi.net')) {
//     //dsp测试
//     login = testLogin;
//     dspDomain = '//testdsp.batmobi.net';
//     dspAdminHost = '//test.admin.batmobi.net/index.html#/';
//     mediaDomain = '//testapi-td.batmobi.net';
// } else if (location.host.includes('test.admin.batmobi.net')) {
//     //dspAdmin测试
//     login = testLogin;
//     dspHost = '//test.group.batmobi.net';
//     dspDomain = '//testdsp.batmobi.net';
// } else if (location.host.includes('d.batmobi.net')) {
//     //dsp正式
//     dspDomain = '//portalapi.adfundsp.com';
//     dspAdminHost = '//dspadmin.adfundsp.com/index.html#/';
//     mediaDomain = '//tdweb.batmobi.net';
// } else if(location.host.includes('test-dspadmin.adfundsp.com')){
//     //测试环境 test-dspadmin.adfundsp.com'  admin端
//     console.log(111)
//     login = testLogin;
//     loginApi = testloginApi
//     dspHost = ' //test-portal.adfundsp.com';
//     dspDomain = '//test-portalapi.adfundsp.com';
//     dspAdminHost = '//test-dspadmin.adfundsp.com/index.html#/';
//     mediaDomain = '//test-tdweb.batmobi.net';
//     console.log('dspDomain',dspDomain)
// } else if (location.host.includes('dspadmin.adfundsp.com')) {
//     //dspAdmin正式
//     dspHost = ' //portal.adfundsp.com';
//     dspDomain = '//portalapi.adfundsp.com';
//     mediaDomain = '//tdweb.batmobi.net';
// }else{
//     //其他情况
//     dspDomain = '//portalapi.adfundsp.com';
//     dspAdminHost = '//dspadmin.adfundsp.com/index.html#/';
//     mediaDomain = '//tdweb.batmobi.net';
//     console.log('dspDomain',dspDomain)
// }

const port = {
  login,
  loginApi,
  dspAdminHost,
  dspIndex: `${dspHost}/index`, //dsp首页
  cpiIndex: `${dspHost}/promotionDetailCPI`, //cpi首页
  translate: `${dspDomain}/translate`, //翻译接口
  mediaDomain: `${mediaDomain}/home/login-token`,
  //后台
  admin: {
    verifyOffer: `${dspDomain}/admin/verifyOffer`, //审核
    listWaitVerifyOffer: `${dspDomain}/admin/listWaitVerifyOffer`, //获取cpi审核列表
    rtbListWaitVerifyOffer: `${dspDomain}/admin/rtb/listWaitVerifyOffer`, //获取rtb审核列表
  },
  algorithmn: {
    data: `${dspDomain}/algorithmn/data`, //算法数据列表
    downloadData: `${dspDomain}/algorithmn/downloadData`, //下载算法数据
    list: `${dspDomain}/algorithmn/list`, //算法列表
    update: `${dspDomain}/algorithmn/update`, //更新算法
  },
  //广告系列，广告
  series: {
    addOrUpdate: `${dspDomain}/series/addOrUpdate`, //新增(编辑)广告系列
    getDetail: `${dspDomain}/series/getDetail`, //获取广告详情信息
    getCampaignSeriesList: `${dspDomain}/series/getCampaignSeriesList`, //获取广告系列列表
  },
  //广告组
  campaign: {
    batchUpdate: `${dspDomain}/campaign/batchUpdate`, //获取广告系列列表
  },
  //用户
  manager: {
    logout: `${dspDomain}/manager/logOut`, //登出
    getUserData: `${dspDomain}/manager/getUserData`, //获取用户信息
    batchUpdateCampaign: `${dspDomain}/manager/batchUpdateCampaign`, //批量更新推广
    campaignList: `${dspDomain}/manager/campaignList`, //推广管理列表
    cpiCampaignList: `${dspDomain}/manager/cpiCampaignList`, //cpi推广管理列表
    campaignSummary: `${dspDomain}/manager/campaignSummary`, //推广管理列表汇总
    cpiCampaignSummary: `${dspDomain}/manager/cpiCampaignSummary`, //cpi推广管理列表汇总
    batchUpdateCampaignStatus: `${dspDomain}/manager/batchUpdateCampaignStatus`, //批量更新推广状态
    closeOffer: `${dspDomain}/manager/closeOffer`, //关闭创意
    openOffer: `${dspDomain}/manager/openOffer`, //开启创意
    delOffer: `${dspDomain}/manager/delOffer`, //删除创意
    openCampaign: `${dspDomain}/manager/openCampaign`, //开启推广
    closeCampaign: `${dspDomain}/manager/closeCampaign`, //关闭推广
    archiveCampaign: `${dspDomain}/manager/archiveCampaign`, //归档推广
    unArchiveCampaign: `${dspDomain}/manager/unArchiveCampaign`, //还原推广
    updateCPIBidPrice: `${dspDomain}/manager/updateCPIBidPrice`, //CPI出价批量更新
    updateCPIDailyActivity: `${dspDomain}/manager/updateCPIDailyActivity`, //CPI日激活批量更新
    dashboardCampaignInfo: `${dspDomain}/manager/dashboardCampaignInfo`, //首页推广情况
    dashboardSummary: `${dspDomain}/manager/dashboardSummary`, //首页数据概览
    getCampaign: `${dspDomain}/manager/getCampaign`, //获取指定推广
    getCampaignTypeList: `${dspDomain}/manager/listCampaignType`, //获取推广类型名称
    getCountryList: `${dspDomain}/manager/getCountryList`, //获取国家信息
    getLanguageList: `${dspDomain}/manager/getLanguageList`, //获取国家信息
    getOsList: `${dspDomain}/manager/getOsList`, //获取系统列表
    getAppList: `${dspDomain}/manager/listApp`, //获取媒体包名
    getCreativeList: `${dspDomain}/manager/creativeList`, //获取媒体包名
    getSourceList: `${dspDomain}/manager/getSourceList`, //获取渠道广告位
    getCategoryList: `${dspDomain}/manager/getCategoryList`, //获取媒体分类
    addCampaign: `${dspDomain}/manager/addCampaign`, //新建推广
    updateCampaign: `${dspDomain}/manager/updateCampaign`, //编辑推广
    uploadImg: `${dspDomain}/manager/uploadImg`, //上传图片
    getTargetDeviceGroups: `${dspDomain}/manager/getTargetDeviceGroups`, //获取定向设备分组
    listBundles: `${dspDomain}/manager/listBundles`, //获取子渠道
  },
  //规则
  rule: {
    getRuleList: `${dspDomain}/rule/getRuleList`, //获取规则
    addRule: `${dspDomain}/rule/addRule`, //添加规则
    updateRule: `${dspDomain}/rule/updateRule`, //更新规则
    deleteRule: `${dspDomain}/rule/deleteRule`, //删除规则
  },
  //报表
  report: {
    data: `${dspDomain}/report/data`, //获取报表页列表
    summary: `${dspDomain}/report/summary`, //获取汇总
    download: `${dspDomain}/report/download`, //报表下载
    campaignSearch: `${dspDomain}/report/campaign/search`, //获取推广下拉列表
    dimensionList: `${dspDomain}/report/dimension/list`, //获取指标下拉列表
  },
  //离线报表
  offlineReport: {
    list: `${dspDomain}/offlineReport/list`, //任务列表
    addOrUpdate: `${dspDomain}/offlineReport/addOrUpdate`, //新建/编辑任务
    restart: `${dspDomain}/offlineReport/restart`, //重跑任务
    delete: `${dspDomain}/offlineReport/delete`, //删除任务
    download: `${dspDomain}/offlineReport/download`, //下载报表
  },
  log: {
    searchList: `${dspDomain}/log/findOperateTarget`,
    listOperators: `${dspDomain}/log/listOperators`,
    offlineReport: `${dspDomain}/log/list`,
  },
  // 广告系列
  seriesTable: {
    offerBatchUpdate: `${dspDomain}/offer/batchUpdate`, //批量广告更新状态
    // seriesList: `${dspDomain}/series/listCampaignSeriesReport`, // 广告系列列表
    seriesList: `${dspDomain}/globalReport/list`, // 广告系列列表
    seriesListDownLoad: `${dspDomain}/series/downloadCampaignSeriesReport`, //广告系列列表导出
    // groupList: `${dspDomain}/series/listCampaignReport`, //广告组列表
    groupList: `${dspDomain}/globalReport/list`, //广告组列表

    groupListDownLoad: `${dspDomain}/series/downloadCampaignReport`, //广告组列表导出
    // adList: `${dspDomain}/series/listOfferReport`, //广告列表
    adList: `${dspDomain}/globalReport/list`, //广告列表
    adListDownLoad: `${dspDomain}/series/downloadOfferReport`, //广告列表导出
    batchUpdate: `${dspDomain}/series/batchUpdate`, //批量更新状态
  },
  //全局数据
  globalReport: {
    list: `${dspDomain}/globalReport/list`, //全局数据-列表
    download: `${dspDomain}/globalReport/download`, //全局数据-下载
    downloadAdmin: `${dspDomain}/globalReport/downloadAdmin`, //广告管理-下载
    getBlackAdsense: `${dspDomain}/globalReport/getBlackAdsense`, //全局数据-获取黑名单广告位ID
    updateBlackAdsense: `${dspDomain}/globalReport/updateBlackAdsense`, //全局数据-更新黑名单广告位
  },
  pmt: {
    userInfoList: `${dspDomain}/userInfo/userList`, //客户信息
    addbalanceAdmin: `${dspDomain}/balanceAdmin/pay`, //新增打款
    seriesList: `${dspDomain}/balanceAdmin/rechargeList`, // 广告系列列表
    balanceAll: `${dspDomain}/balanceAdmin/balanceAll`, //余额账号
  },
  //代码
  code: {
    verifyStatsCode: `${dspDomain}/code/verifyStatsCode`,
  },
  /** 资产 */
  property: {
    // 应用管理
    applicationManager: {
      // 列表
      list: `${dspDomain}/app/list`,
    },
  },
};

export default port;



// WEBPACK FOOTER //
// ./src/server/port.js